import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import Mylogo from "../assets/Image/logo (4).png";

const NAV_LINKS = [
  { name: "Home", href: "#" },
  { name: "About", href: "#about" },
  { name: "Services", href: "#services" },
  { name: "Projects", href: "#projects" },
  { name: "Contact", href: "#contact" }
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50 transition-all duration-300 ease-in-out">
      <div className="container mx-auto flex justify-between items-center py-4 px-8 transform transition-all duration-300 ease-in-out">
        {/* Logo + Text */}
        <div className="flex items-center space-x-3 transform transition-all duration-300 ease-in-out hover:scale-105">
          <img
            src={Mylogo}
            alt="Pixel Prime Logo"
            className="h-12 w-auto object-contain transition-transform duration-300 ease-in-out hover:rotate-3"
          />
          <span className="text-2xl font-extrabold text-indigo-700 tracking-wide transition-colors duration-300 hover:text-indigo-800">
            Pixel Prime
          </span>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-10 text-gray-700 font-semibold items-center">
          {NAV_LINKS.map(({ name, href }) => (
            <li key={name} className="relative transition-all duration-300 ease-in-out hover:scale-105">
              <a
                href={href}
                className="relative group px-3 py-2 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                aria-label={name}
              >
                {name}
                <span
                  className="absolute left-0 -bottom-1 w-0 h-0.5 bg-indigo-600 transition-all duration-300 ease-in-out group-hover:w-full"
                  aria-hidden="true"
                />
              </a>
            </li>
          ))}
          {/* CTA */}
          <li className="transition-all duration-300 ease-in-out hover:scale-105">
            <a
              href="#get-started"
              className="ml-6 px-5 py-2 rounded-full text-white bg-indigo-600 shadow-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out transform hover:-translate-y-1"
              aria-label="Get Started"
            >
              Get Started
            </a>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button
            aria-label={isOpen ? "Close menu" : "Open menu"}
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transition-transform duration-300 ease-in-out hover:scale-110"
          >
            {isOpen ? <X size={28} className="transition-transform duration-300 ease-in-out" /> : <Menu size={28} className="transition-transform duration-300 ease-in-out" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg border-t animate-fadeInUp">
          <ul className="flex flex-col items-center space-y-5 py-6 text-gray-700 font-semibold">
            {NAV_LINKS.map(({ name, href }) => (
              <li key={name} className="w-full text-center transition-all duration-300 ease-in-out hover:bg-gray-50">
                <a
                  href={href}
                  onClick={() => setIsOpen(false)}
                  className="block px-8 py-3 rounded-lg hover:bg-indigo-50 focus:bg-indigo-100 focus:outline-none transition-all duration-300 ease-in-out"
                  aria-label={name}
                >
                  {name}
                </a>
              </li>
            ))}
            <li className="w-full text-center">
              <a
                href="#get-started"
                className="mt-4 px-6 py-2 rounded-full text-white bg-indigo-600 shadow-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out transform hover:-translate-y-1"
                aria-label="Get Started"
              >
                Get Started
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;